import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  escritosList:[],
  expedientesList:[],
  currentOrden: JSON.parse(localStorage.getItem("currentOrden")) || ''
};

export const mutations = {
  GET_ESCRITOS({ context }, escritos) {
    let escritos_array = [];
    Object.entries(escritos).forEach(([key, val]) => escritos_array.push(val));
    return (state.escritosList = escritos_array);
  },
  GET_EXPEDIENTES({ context }, expedientes) {
    let expedientes_array = [];
    Object.entries(expedientes).forEach(([key, val]) => expedientes_array.push(val));
    return (state.expedientesList = expedientes_array);
  },
  SHOW_EXPEDIENTE ({ context }, laboral) {
    state.currentOrden = Object.assign({}, laboral);
    localStorage.setItem("currentOrden", JSON.stringify(state.currentOrden));
  }
};

export const actions = {

  SAVE_INITIAL_EXPEDIENTE({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SHOW_PROMOCION", response.data.data.promocion);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_ESCRITOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // console.log(response.data);
          commit("GET_ESCRITOS", response.data.data.expedientes);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_EXPEDIENTES({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // console.log(response.data);
          commit("GET_EXPEDIENTES", response.data.data.expedientes);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SHOW_EXPEDIENTE({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data.laboral);
          commit("SET_LOADING", false);
          commit("SHOW_EXPEDIENTE", response.data.data.laboral);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

};

export const getters = {
  escritosList: state => state.escritosList,
  expedientesList: state => state.expedientesList,
  // currentOrden: state => state.currentOrden,
};
